import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsLegsOptions = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.legs.options;

export const options = setCalculationModeAdminSettingsLegsOptions(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_LEGS_OPTIONS',
  []
);
